/* src/app/delivery-defense/dd-agreement-beta-dialog/dd-agreement-beta-dialog.component.scss */
.dialog-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  height: 100%;
  padding: 1rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content {
    padding: 2rem;
  }
}
.dialog-content .title {
  font-size: 1.5rem;
  font-weight: 700;
}
.dialog-content .content {
  flex: 1;
  border: solid thin #D9D9D9;
  border-radius: 4px;
  padding: 1rem;
  min-height: 10rem;
  max-height: 39rem;
  overflow: auto;
}
.dialog-content .content ::ng-deep p {
  font-size: 0.9rem;
}
.dialog-content form {
  margin-top: auto;
  padding: 1rem 0;
}
@media screen and (min-width: 48rem) {
  .dialog-content form {
    padding-bottom: 0;
  }
}
.dialog-content form .message.agree {
  font-size: 0.8rem;
}
.dialog-content form .actions {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  justify-content: space-around;
  column-gap: 1rem;
}
@media screen and (min-width: 48rem) {
  .dialog-content form .actions {
    justify-content: flex-end;
  }
}
.dialog-content form .actions .action {
  min-width: 8rem;
}
:host(.dd-agreement-beta-dialog) {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
}
/*# sourceMappingURL=dd-agreement-beta-dialog.component.css.map */
